'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withFilters = undefined;

var _is = require('ramda/src/is');

var _is2 = _interopRequireDefault(_is);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _recompose = require('recompose');

var _vxFilterContainer = require('../vx-filter-container');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withFilters = exports.withFilters = function withFilters(Component) {
  return (0, _recompose.compose)((0, _recompose.withState)('filters', 'setFilters', function (_ref) {
    var activeFilterId = _ref.activeFilterId;
    return { activeFilterId: activeFilterId };
  }), (0, _recompose.withHandlers)({
    onChangeActiveFilter: function onChangeActiveFilter(_ref2) {
      var setFilters = _ref2.setFilters,
          changeActiveFilter = _ref2.changeActiveFilter;
      return function (activeFilterId) {
        return function () {
          setFilters(function (state) {
            var newState = _extends({}, state, {
              activeFilterId: activeFilterId === state.activeFilterId ? null : activeFilterId
            });
            if ((0, _is2.default)(Function, changeActiveFilter)) changeActiveFilter(newState);
            return newState;
          });
        };
      };
    }
  }))(Component);
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/vx-filters/with-filters.js
// module id = 2035
// module chunks = 0